/*
 * Emblyss - bundle progress.
 *
 * Drives two things from one cart count: the slots inside the bundle band on the
 * homepage, and the sticky bar that follows the customer on phones.
 *
 * WHERE THE COUNT COMES FROM. Horizon dispatches 'cart:update' on document (see
 * assets/events.js). Read detail.resource.item_count and NOTHING ELSE.
 * detail.data.itemCount looks like the obvious field and is documented in
 * Horizon's own JSDoc as "the number of items in the cart" - it is not.
 * assets/product-form.js sets it to the quantity added in that one action, which
 * is 1 every time from our cards. Trusting it is what made the earlier cart
 * nudge sit permanently one step behind the real cart.
 *
 * Liquid server-renders the correct state, so everything here is a follow-up
 * rather than a first paint.
 */
(function () {
  'use strict';

  if (window.__emblyssBundle) return;
  window.__emblyssBundle = true;

  var THRESHOLD = 3;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var dismissed = false;
  var celebrated = false;
  // The store uses a cart drawer, which slides over the whole page on every
  // add. Anything that happens on the page behind it is simply not seen, so a
  // celebration earned while the drawer is open is held back until it closes.
  var drawerOpen = false;
  var celebrationPending = false;

  var CONFETTI_COLORS = ['#b48c68', '#9caf88', '#96714f', '#e6e1d8', '#51514d'];


  function bandMessage(count) {
    var left = THRESHOLD - count;
    if (left <= 0) return '25% off applied to your order';
    if (left === 1) return 'One more to go';
    if (left === 2) return 'Two more to go';
    return 'Add any three oils to your cart';
  }

  function stickyMessage(count) {
    var left = THRESHOLD - count;
    if (left <= 0) return 'You earned 25% off';
    if (left === 1) return 'Add 1 more, get 25% off';
    if (left === 2) return 'Add 2 more, get 25% off';
    return 'Add 3 oils, get 25% off';
  }

  function pop(el) {
    if (reduced.matches || !el) return;
    el.classList.remove('em-pop');
    void el.offsetWidth; // force reflow so the animation restarts
    el.classList.add('em-pop');
  }

  /* Fill slots left to right, popping only the ones that just changed. */
  function paintSlots(root, count, animate) {
    var slots = root.querySelectorAll('[data-em-slot]');
    for (var i = 0; i < slots.length; i++) {
      var shouldFill = i < count;
      var isFilled = slots[i].classList.contains('is-filled');
      if (shouldFill === isFilled) continue;
      slots[i].classList.toggle('is-filled', shouldFill);
      if (shouldFill && animate) pop(slots[i]);
    }
  }

  function confetti(host) {
    if (reduced.matches || !host) return;
    var n = 20;
    for (var i = 0; i < n; i++) {
      var bit = document.createElement('span');
      bit.className = 'em-confetti-bit';
      var angle = (Math.PI * (0.15 + 0.7 * (i / n))) * -1; // fan upward
      var dist = 70 + Math.random() * 90;
      bit.style.setProperty('--dx', (Math.cos(angle) * dist).toFixed(1) + 'px');
      bit.style.setProperty('--dy', (Math.sin(angle) * dist + 90).toFixed(1) + 'px');
      bit.style.setProperty('--rot', Math.round(Math.random() * 720 - 360) + 'deg');
      bit.style.setProperty('--dur', 900 + Math.round(Math.random() * 500) + 'ms');
      bit.style.background = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
      bit.addEventListener('animationend', function () {
        if (this.parentNode) this.parentNode.removeChild(this);
      });
      host.appendChild(bit);
    }
  }

  function render(count, animate) {
    var band = document.querySelector('[data-em-bundle]');
    if (band) {
      band.classList.toggle('em-bundle--done', count >= THRESHOLD);
      paintSlots(band, count, animate);
      var bandMsg = band.querySelector('[data-em-bundle-msg]');
      if (bandMsg) bandMsg.textContent = bandMessage(count);
    }

    var sticky = document.querySelector('[data-em-sticky]');
    if (sticky) {
      sticky.classList.toggle('em-sticky--done', count >= THRESHOLD);
      paintSlots(sticky, count, animate);
      var stickyMsg = sticky.querySelector('[data-em-sticky-msg]');
      if (stickyMsg) stickyMsg.textContent = stickyMessage(count);
    }

    // Fire only on the transition INTO three, not on every event while at 3+.
    if (animate && count >= THRESHOLD && !celebrated) {
      celebrated = true;
      if (drawerOpen) celebrationPending = true;
      else confetti(document.querySelector('[data-em-confetti]'));
    }
    if (count < THRESHOLD) {
      celebrated = false;
      celebrationPending = false;
    }
  }

  /* ---- sticky bar visibility ---- */

  function showSticky(show) {
    var sticky = document.querySelector('[data-em-sticky]');
    if (!sticky || dismissed) return;
    sticky.classList.toggle('is-visible', !!show);
  }

  /*
    Visibility is a plain scroll check on every page type.

    This replaced an IntersectionObserver watching the bundle band. That version
    was correct on paper and never appeared in practice, and an observer's state
    is invisible from outside the browser - which made it impossible to tell
    whether it had fired at all. A scroll offset is dumber, behaves identically
    on the homepage and a product page, and can be reasoned about from the page
    itself.
  */
  var SHOW_AFTER = 280;

  function syncSticky() {
    if (dismissed || drawerOpen) return;
    showSticky(window.scrollY > SHOW_AFTER);
  }

  function watchBand() {
    if (!document.querySelector('[data-em-sticky]')) return;
    window.removeEventListener('scroll', syncSticky);
    window.addEventListener('scroll', syncSticky, { passive: true });
    syncSticky();
  }

  function bindClose() {
    var btn = document.querySelector('[data-em-sticky-close]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      dismissed = true;
      showSticky(false);
    });
  }

  /* ---- wiring ---- */

  function readCount(detail) {
    if (!detail) return null;
    var r = detail.resource;
    return r && typeof r.item_count === 'number' ? r.item_count : null;
  }

  document.addEventListener('cart:update', function (e) {
    var count = readCount(e.detail);
    if (count !== null) { render(count, true); return; }
    // Some cart events carry no cart object; ask for it rather than guessing.
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart.item_count, true); })
      .catch(function () { /* leave the server-rendered state alone */ });
  });

  // The cart drawer and the sticky bar both live at the bottom of the screen,
  // so the bar gets out of the way while the drawer is open.
  //
  // Note the third argument. Horizon builds these with "new CustomEvent(name)"
  // and no options, which means bubbles: false, and dispatches them on the
  // dialog element itself (assets/dialog.js). A plain listener on document
  // would never fire. Capture-phase listeners still see non-bubbling events on
  // the way down to the target, which is why this works.
  document.addEventListener('dialog:open', function () {
    drawerOpen = true;
    showSticky(false);
  }, true);

  document.addEventListener('dialog:close', function () {
    drawerOpen = false;
    watchBand();
    if (!celebrationPending) return;
    celebrationPending = false;
    // Let the drawer finish sliding away before the confetti goes off, or it
    // fires against a screen the customer is still not looking at.
    setTimeout(function () {
      var band = document.querySelector('[data-em-bundle]');
      if (band) {
        var slots = band.querySelectorAll('[data-em-slot].is-filled');
        if (slots.length) pop(slots[slots.length - 1]);
      }
      confetti(document.querySelector('[data-em-confetti]'));
    }, 320);
  }, true);

  function init() {
    var band = document.querySelector('[data-em-bundle]');
    if (band && band.dataset.threshold) THRESHOLD = parseInt(band.dataset.threshold, 10) || 3;
    // Seed from what Liquid already rendered, so nothing re-animates on load
    // and the confetti does not re-fire for a cart that was already at three.
    var filled = document.querySelectorAll('[data-em-bundle] [data-em-slot].is-filled').length;
    celebrated = filled >= THRESHOLD;
    watchBand();
    bindClose();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () { watchBand(); });
})();
